import { DATASET_CONTROL_DATA_PARAM } from '../../constants';

// Carries the dataset control data param from the current URL over to a
// navigation target — e.g. the form-token fromUrl, so a form round-trip
// (incl. F5 inside the form; tokens persist) returns to the dataset with the
// data still applied.
export const appendDatasetControlDataParam = (
  path: string,
  search: string
): string => {
  const raw = new URLSearchParams(search).get(DATASET_CONTROL_DATA_PARAM);
  if (raw === null) {
    return path;
  }

  const params = new URLSearchParams();
  params.set(DATASET_CONTROL_DATA_PARAM, raw);
  return `${path}${path.includes('?') ? '&' : '?'}${params.toString()}`;
};
